import { AssetMarkerProps } from './asset-marker/AssetMarker';
import { useMemo } from 'react';
import {
  LiveAssetLocationModel,
  RegisteredAssetModel,
} from '@casops/store/apis/registeredAssetsApi';

export interface LiveAssetsMarkersProps {
  assets: RegisteredAssetModel[];
  assetsLocations: LiveAssetLocationModel[];
}

/**
 * Prepare all marker props in one step to avoid sifting through the assets more than once.
 */
export const useLiveAssetsMarkers = ({
  assets,
  assetsLocations,
}: LiveAssetsMarkersProps): AssetMarkerProps[] => {
  return useMemo<AssetMarkerProps[]>(() => {
    const markerProps: AssetMarkerProps[] = [];

    for (let i = 0; i < assetsLocations.length; i++) {
      const loc = assetsLocations[i];
      if (typeof loc.lat !== 'number' || typeof loc.lon !== 'number') continue;

      const asset = assets.find(asset => asset.id === loc.id);
      if (!asset) continue;

      markerProps.push({
        id: loc.id,
        position: [loc.lat, loc.lon],
        heading: loc.hd,
        label: asset.n,
        obj: asset.obj,
      });
    }

    return markerProps;
  }, [assets, assetsLocations]);
};
